<template>
  <b-card>
    <div>
      <Strong>Rider-Wise Performance Report</Strong>

      <b-row class="mt-4">
        <b-col >                    
          <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >OFD Report</a>
              </li>

              <!-- <li class="nav-item">
                <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">OFP Report</a>
              </li>             -->
            </ul>
          </div>                       
        </b-col>
      </b-row>

      <component :is="currentComponent" class="mt-3"></component>
    </div>
  </b-card>
</template>
  
<script>
import riderWiseOFDReport_KSA from './riderWiseOFDReport_KSA.vue';
import riderWiseOFPReport_KSA from './riderWiseOFPReport_KSA.vue';
  export default {
    components: {
      riderWiseOFDReport_KSA,
      riderWiseOFPReport_KSA
    },
    data: function(){
      return{
        activeTab: 1,
        name: 'riderWisePerformanceReport_KSA',
      }
    },
    computed: {
      currentComponent(){
        if(this.activeTab === 1)           
          return "riderWiseOFDReport_KSA";
        else
          return "riderWiseOFPReport_KSA";
      }
    },
    created: function(){
      this.isActiveTab(1);
    },
    methods:{
      isActiveTab(id)
      {
        return this.activeTab === id;
      }
    }
  };
</script>

<style>

</style>